"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = void 0;
var _react = require("react");
var _Snackbar = _interopRequireDefault(require("./Snackbar.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Snackbar = function Snackbar(props) {
  var contentText = props.contentText,
    zIndex = props.zIndex,
    timeout = props.timeout,
    onTimeout = props.onTimeout;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var styles = (0, _Snackbar.default)(isHidden, zIndex);
  (0, _react.useEffect)(function () {
    var timer;
    var startTimer = timeout && timeout > 0 && contentText;
    setIsHidden(!startTimer);
    if (startTimer) {
      timer = setTimeout(function () {
        setIsHidden(true);
        if (onTimeout) {
          onTimeout();
        }
      }, timeout);
    }
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [contentText, onTimeout, timeout]);
  var ariaLiveValue = isHidden ? 'off' : 'assertive';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Snackbar'],
    role: "alert",
    "aria-live": ariaLiveValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: contentText
    })
  });
};
exports.Snackbar = Snackbar;